export { default as MainPageNLP } from './MainPageNLP';